import { render, staticRenderFns } from "./roleInfoModal.vue?vue&type=template&id=b807766c&scoped=true"
import script from "./roleInfoModal.vue?vue&type=script&lang=js"
export * from "./roleInfoModal.vue?vue&type=script&lang=js"
import style0 from "./roleInfoModal.vue?vue&type=style&index=0&id=b807766c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b807766c",
  null
  
)

export default component.exports